import { MailSubjectDTO, MailSubjectSTO } from "src/models/mail-subject";
import { BaseApiService } from "../base";

export class MailSubjectApiService extends BaseApiService<MailSubjectDTO, MailSubjectSTO> {
  constructor() {
    super({
      servicePath: "/MailSubject",
      loadItemsPath: "/GetMailSubjects",
      saveItemsPath: "/SaveMailSubjects",
    });
  }
}
